//require("./scss/styles.scss");
require("./js/law.js");